enum REPORT_HISTORY_TYPES {
  REPORT,
  CHARACTER,
}
export default REPORT_HISTORY_TYPES;
